import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  Typography,
  Box,
  Zoom,
  styled
} from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

/**
 * Componente "WowOverlay" - Versione Premium Smooth
 * Rettangolo arrotondato centrale con sfocatura dello sfondo (glassmorphism).
 * Supporta stati di 'success', 'error' e 'loading'.
 */
const WowDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    backdropFilter: 'blur(8px)',
    transition: 'opacity 400ms cubic-bezier(0.4, 0, 0.2, 1) !important',
  },
  '& .MuiDialog-paper': {
    borderRadius: '40px',
    padding: theme.spacing(5),
    minWidth: '320px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 20px 40px rgba(0,0,0,0.12)',
    border: '1px solid rgba(255,255,255,0.3)',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  }
}));

const WowOverlay = ({
  open,
  state, // 'success', 'error', 'loading'
  errorMessage = "",
  onClose
}) => {

  const isError = state === 'error' || state === false;
  const isSuccess = state === 'success';

  const displayMessage = errorMessage || (isSuccess ? "Operazione completata!" : "Si è verificato un problema!");

  // Extract nested ternary operations into independent statements
  let bgColor = "#f8fafc";
  if (isSuccess) {
    bgColor = "#e8f5e9";
  } else if (isError) {
    bgColor = "#ffebee";
  }

  let iconColor = "#0b3d87";
  if (isSuccess) {
    iconColor = "#4caf50";
  } else if (isError) {
    iconColor = "#f44336";
  }

  return (
    <WowDialog
      open={open}
      slots={{ transition: Zoom }}
      slotProps={{
        transition: {
          timeout: { enter: 400, exit: 300 }
        }
      }}
      disableEnforceFocus
      disableAutoFocus
      hideBackdrop={false}
      disableScrollLock={true}
      onClose={onClose}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: bgColor,
          borderRadius: '50%',
          p: 2,
          mb: 1,
          transition: 'all 0.3s'
        }}>
          {isError && <HighlightOffIcon sx={{ fontSize: 80, color: iconColor }} />}
          {isSuccess && <CheckCircleOutlineIcon sx={{ fontSize: 80, color: iconColor }} />}
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 800,
            color: '#1a202c',
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          {displayMessage}
        </Typography>
      </Box>
    </WowDialog>
  );
};

WowOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorMessage: PropTypes.string,
  onClose: PropTypes.func
};

export default WowOverlay;
 